// ============================================
// MAPLEFAIR FAQ — Smooth Accordion
// ============================================

(function() {
  'use strict';

  window.toggleMfFaq = function(button) {
    const item = button.closest('.mf-faq__item');
    const answer = item.querySelector('.mf-faq__answer');
    const isExpanded = button.getAttribute('aria-expanded') === 'true';

    // Close all other items (optional — remove this block for multi-open)
    const allItems = item.closest('.mf-faq__list').querySelectorAll('.mf-faq__item');
    allItems.forEach(otherItem => {
      if (otherItem !== item) {
        const otherBtn = otherItem.querySelector('.mf-faq__question');
        const otherAnswer = otherItem.querySelector('.mf-faq__answer');
        otherBtn.setAttribute('aria-expanded', 'false');
        otherAnswer.setAttribute('aria-hidden', 'true');
        otherAnswer.classList.remove('open');
      }
    });

    // Toggle current
    if (isExpanded) {
      button.setAttribute('aria-expanded', 'false');
      answer.setAttribute('aria-hidden', 'true');
      answer.classList.remove('open');
    } else {
      button.setAttribute('aria-expanded', 'true');
      answer.setAttribute('aria-hidden', 'false');
      answer.classList.add('open');
    }
  };

  // Keyboard support: Enter and Space to toggle
  document.addEventListener('keydown', function(e) {
    if (e.key === 'Enter' || e.key === ' ') {
      const btn = e.target.closest('.mf-faq__question');
      if (btn) {
        e.preventDefault();
        toggleMfFaq(btn);
      }
    }
  });

  // Optional: Open first FAQ by default
  document.addEventListener('DOMContentLoaded', function() {
    const firstFaq = document.querySelector('.mf-faq__question');
    if (firstFaq && !firstFaq.closest('.mf-faq').dataset.noAutoOpen) {
      // Uncomment next line to auto-open first item:
      // toggleMfFaq(firstFaq);
    }
  });

})();